// Create a GrowthBook instance
const clientId = document.cookie.match(/_ga=(.+?);/)[1].split('.').slice(-2).join(".");
const gb = new window.growthbook.GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: "sdk-NLRM3OQaVUVV1W",
  // Enable easier debugging during development
  enableDevMode: true,
  // Update the instance in realtime as features change in GrowthBook
  subscribeToChanges: true,
  // Targeting attributes
  attributes: {
    id: clientId,
  },
  // Only required for A/B testing
  // Called every time a user is put into an experiment
  trackingCallback: (experiment, result) => {
    // track using GA4
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'experiment_viewed',
      'event_category': 'experiment',
      'experiment_id': experiment.key,
      'variation_id': result.variationId
    });
    console.log("dataLayer experiment event sent", {
      experiment_id: experiment.key,
      variation_id: result.variationId,
    });
  },
});

// Wait for features to be available
await gb.loadFeatures();
